import React from 'react'
import { compose, branch } from 'recompose'
import { Redirect } from 'react-router-dom'
import { withRootDir } from 'src/composables'

const enabled = process.env.REACT_APP_STYLEGUIDE === 'enabled'

const StyleguideContainer = compose(
  branch(() => !enabled, () => () => <Redirect to='/' />),
  withRootDir
)

export default StyleguideContainer
